import styled, {createGlobalStyle} from "styled-components";
import Montserrat from "../assets/fonts/montserrat/Montserrat-Light.otf";
import MontserratRegular from "../assets/fonts/montserrat/Montserrat-Regular.otf";
import MontserratLight from "../assets/fonts/montserrat/Montserrat-UltraLight.otf";
import MontserratHair from "../assets/fonts/montserrat/Montserrat-Hairline.otf";
import MontserratBold from "../assets/fonts/montserrat/Montserrat-Bold.otf";
import MontserratSemiBold from "../assets/fonts/montserrat/Montserrat-SemiBold.otf";
import Color from "../assets/Colors";

const GlobalStyle = createGlobalStyle`
   /* * {
      border: 1px solid red;
   } */
 
   @font-face { 
      font-family: 'Montserrat';
      font-weight: 100;
      src: url(${MontserratHair});
   }
   @font-face {
      font-family: 'Montserrat';
      font-weight: 200;
      src: url(${MontserratLight});
   }
   @font-face {
      font-family: 'Montserrat';
      font-weight: 300;
      src: url(${Montserrat});
   }
   @font-face {
      font-family: 'Montserrat';
      font-weight: 400;
      src: url(${MontserratRegular});
   }
   @font-face {
      font-family: 'Montserrat';
      font-weight: 500;
      src: url(${MontserratSemiBold});
   }
   @font-face {
      font-family: 'Montserrat';
      font-style: bold;
      font-weight: 600;
      src: url(${MontserratBold});
   }
  body {
    margin: 0;
    height: 100%;
    font-family: Montserrat;
  }
  ul, p {
     padding: 0;
     margin: 0em;
  }
  section, div, article, nav, header, span, input, select, textarea {
     box-sizing: border-box;
     font-family: Montserrat;
  }
  section, div, article, p, a, button, ul, li, :after, :before, :hover {
     transition: all 420ms linear;
  }
  a{
     text-decoration: none;
  }
  button, a, p, span, label, b,  {
   font-family: Montserrat;
  }

  button.react-multiple-carousel__arrow, .react-multiple-carousel__arrow:hover {
     background: transparent;
  }
  button.react-multiple-carousel__arrow.react-multiple-carousel__arrow--right{
     right: calc(4% + -0.7em);
     top: 50%
  }
  button.react-multiple-carousel__arrow.react-multiple-carousel__arrow--left{
     left: calc(4% + -0.7em);
     top: 50%
  }

  @media screen and (max-width: 850px) {
      button.react-multiple-carousel__arrow.react-multiple-carousel__arrow--right{
         right: calc(4% + -2.5em);
         top: 50%
      }
      button.react-multiple-carousel__arrow.react-multiple-carousel__arrow--left{
         left: calc(4% + -2.5em);
         top: 50%
      }
  }

  input[type=number]::-webkit-inner-spin-button, 
   input[type=number]::-webkit-outer-spin-button { 
      -webkit-appearance: none; 
   }

   input[type=number] { -moz-appearance:textfield; }

`;

export default GlobalStyle;

export const Main = styled.section`
   width: 100%;
   padding: ${(props) => props.padding || "0.8em"};
   position: relative;

   & .react-multi-carousel-list.carousel-container {
      height: inherit;
   }
   @media screen and (max-width: 1600px) {
      padding: 0.7em;
      & .react-multi-carousel-list.carousel-container {
         //height: 68vh;
      }
   }

   @media screen and (max-width: 1400px) {
      padding: 0.5em;
   }
   @media screen and (max-width: 500px) {
      padding: 0.3em;
   }
`;

export const Content = styled.section`
   width: 82vw;
   height: 100%;
   margin: 0 auto;
   position: relative;

   &:after {
      // descomentar la siguiente linea para ver
      // lineas punteadas del contenedor y saber la alinecación de todo
      // content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 1px dashed ${(props) => props.color || "red"};
      z-index: 100000;
   }

   & .stylesPrime {
      margin-bottom: 110px;
   }

   @media screen and (max-width: 1600px) {
      width: 80vw;
   }

   @media screen and (max-width: 1000px) {
      width: 85vw;
   }

   @media screen and (max-width: 800px) {
      width: 88vw;
   }
   < @media screen and (max-width: 500px) {
      width: 88vw;

      & .stylesPrime {
         margin-bottom: 44px;
      }

      & .styleFormContact {
         margin-bottom: 40px;
      }
   }

   textarea {
      resize: none;
   }
`;

export const SelectedContainer = styled.label`
   background: red;
   margin-bottom: 1em;
   position: relative;
   width: 100%;

   & .arrow {
      position: absolute;
      /* border: solid black;
      border-width: 0 3px 3px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg); */
      right: 0;
      top: 40%;
      width: 10px;
      height: 10px;
   }
`;

export const SelectStyled = styled.select`
   width: 100%;
   height: 100%;
   border: none;
   outline: none;
   border-bottom: 1px solid ${Color.textColor};
   color: ${(props) => props.color || Color.textColor};
   font-size: 1.4em;
   font-weight: 200;
   padding: 0.5em;
   background-color: white;
   outline: none;
   appearance: none;
   position: relative;

   option {
      font-size: 1.4em;
      font-weight: 200;
      font-family: Montserrat, Arial;

      /* &:hover {
         box-shadow: 0 0 10px 100px red inset;
      } */
   }

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
   }
`;
